var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66716 44.8173V44.8167L8.66716 4.18299L8.66716 4.18242C8.66712 4.13807 8.67595 4.09388 8.69342 4.0523C8.7109 4.01068 8.73684 3.97217 8.77027 3.93925C8.80373 3.90629 8.84403 3.87959 8.88915 3.86119C8.93429 3.84278 8.98304 3.83317 9.03252 3.83317H30.9534L39.3338 12.0812V44.8167V44.8173C39.3339 44.8616 39.325 44.9058 39.3076 44.9474C39.2901 44.989 39.2641 45.0275 39.2307 45.0604L39.6737 45.5102L39.2307 45.0604C39.1973 45.0934 39.1569 45.1201 39.1118 45.1385C39.0667 45.1569 39.0179 45.1665 38.9685 45.1665H9.03252C8.98304 45.1665 8.93429 45.1569 8.88915 45.1385C8.84403 45.1201 8.80372 45.0934 8.77027 45.0604L8.30245 45.5354L8.77026 45.0604C8.73684 45.0275 8.71091 44.989 8.69342 44.9474C8.67595 44.9058 8.66712 44.8616 8.66716 44.8173Z",
    fill: "white",
    stroke: "#E5E5E5",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0136 12.0696H32.0891C31.8298 12.0696 31.5811 11.9666 31.3977 11.7832C31.2143 11.5999 31.1113 11.3512 31.1113 11.0918V3.1665L40.0136 12.0696Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankPage);
export default __webpack_public_path__ + "static/media/blank-page.a7fde36f.svg";
export { ForwardRef as ReactComponent };